export default __webpack_public_path__ + "static/media/location.b4b49131.svg";